import React from "react";

export default function Thoughts() {
    return (
        <div className="section" id="thoughts">
            <h1 className="display-3 pixel-font">My Thoughts</h1>
            <p className="lead nunito-font">
                For my first Phaser project, this was hard. I spent countless
                hours looking at ways I could use Phaser with other technologies
                such as React or Next since it's always my go-to technologies
                when developing and it was a pain to get Phaser to work. I also
                learned about things that I should have learned in the beginning
                of my Web Development journey, specifically Webpack and Parcel.
                There's a lot I need to do to get this application the way I
                want and I want to get better and keep learning to use Phaser.
                It has opened my eyes for different projects I would like to
                work on. For my first Mintbean Hiring Hackathon, it was a
                pleasurable experience and I can't wait to join the next one!
            </p>
        </div>
    );
}
